import FavouriteButtonWithPopover from './FavouriteButtonWithPopover';
export default FavouriteButtonWithPopover;
//# sourceMappingURL=index.js.map